module.exports = __webpack_public_path__ + "static/media/164204_10151823568713273_1374435337_n.b1837868.jpg";